<template>
  <Sheet class="p-4" height="70%">
    <div v-if="totalCount">
      <CartFoodCard v-for="food in foods" :key="food.kala" :food="food" />
      <div class="text-sm rounded-lg border p-4 mt-4">
        <div class="flex justify-between">
          <span>
            جمع کل
            <span class="text-xs">(با مالیات)</span>
            :
          </span>
          <span class="text-theme-500 font-bold">{{
            $helper.priceFormatter(
              this.$store.state.factorSum.paymentAfterTax / 10
            )
          }}</span>
        </div>
        <div class="flex justify-between border-t border-theme-500 mt-2 pt-2">
          <span>مبلغ قابل پرداخت :</span>
          <span class="text-theme-500 font-bold">{{
            $helper.priceFormatter(
              this.$store.state.factorSum.paymentAfterTax / 10
            )
          }}</span>
        </div>
      </div>

      <form action="" @submit.prevent="submitOrder()">
        <div class="flex items-center mt-4">
          <h1 class="text-sm">نوع سفارش</h1>
          <div
            class="border-2 rounded-lg p-3 text-xs mr-4 flex flex-col items-center"
            :class="{ 'border-theme-500': this.orderType === 'restaurant' }"
            @click="this.orderType = 'restaurant'"
          >
            <font-awesome-icon
              icon="fa-solid fa-building"
              class="mb-1 h-5 w-5 mx-auto text-colorfont"
            />
            <span>حضوری</span>
          </div>
          <div
            class="border-2 rounded-lg p-3 text-xs mx-4 flex flex-col items-center"
            :class="{ 'border-theme-500': this.orderType === 'takeout' }"
            @click="this.orderType = 'takeout'"
          >
            <font-awesome-icon
              icon="right-from-bracket"
              class="mb-1 h-5 w-5 mx-auto text-colorfont"
            />
            <span>بیرون بر</span>
          </div>
        </div>

        <transition name="fade">
          <div class="flex mt-4" v-if="orderType === 'restaurant'">
            <VInput
              class="w-full"
              type="number"
              placeholder="تعداد افراد"
              v-model="user.count"
              required
            />

            <VInput
              class="w-full mr-2"
              type="number"
              placeholder="شماره میز"
              v-model="tableNumber"
              required
            />
            <VButton class="px-1 mr-1" @click="cart = false">
              <router-link :to="{ path: '/qr', query: { callback: 'cart' } }">
                <QrcodeIcon class="w-6 h-6" />
              </router-link>
            </VButton>
          </div>
        </transition>

        <VInput
          class="w-full mt-4"
          type="text"
          placeholder="نام و نام خانوادگی"
          v-model="user.name"
          v-if="!$store.state.user.name"
          required
        />

        <div class="flex mt-4" v-if="false">
          <VInput
            class="w-full"
            type="text"
            placeholder="کد تخفیف"
            v-model="discountCode"
            required
          />
          <VButton class="px-1 mr-1" @click="cart = false">
            <router-link to="/qr">
              <CheckIcon class="w-6 h-6" />
            </router-link>
          </VButton>
        </div>

        <VInput
          class="w-full mt-4"
          v-model="description"
          placeholder="توضیحات..."
        />

        <h1 class="text-sm mt-4">نحوه پرداخت</h1>
        <div class="flex items-center mt-2">
          <div
            class="border-2 rounded-lg p-3 text-xs flex flex-col items-center"
            :class="{ 'border-theme-500': this.paymentType === 'online' }"
            @click="this.paymentType = 'online'"
          >
            <font-awesome-icon
              icon="desktop"
              class="mb-1 h-5 w-5 mx-auto text-colorfont"
            />
            <span>آنلاین</span>
          </div>
          <div
            class="border-2 rounded-lg p-3 text-xs mr-4 flex flex-col items-center"
            :class="{ 'border-theme-500': this.paymentType === 'pos' }"
            @click="this.paymentType = 'pos'"
          >
            <font-awesome-icon
              icon="credit-card"
              class="mb-1 h-5 w-5 mx-auto text-colorfont"
            />
            <spa>کارتخوان</spa>
          </div>
        </div>

        <VButton class="w-full mt-4 bg-bgbuttontest text-gray-100" :loading="loading">ثبت</VButton>
      </form>
    </div>
    <div class="mt-16" v-else>
      <h1 class="text-gray-500 text-lg text-center">سبد خرید شما خالی است.</h1>
      <VButton class="w-full mt-4 bg-bgbuttontest text-gray-100">
        <router-link to="/menu" @click="cart = false">شروع سفارش</router-link>
      </VButton>
    </div>
  </Sheet>
</template>

<script>
import VButton from "@/components/General/VButton";
import CartFoodCard from "@/components/CartFoodCard";
import { Sheet } from "bottom-sheet-vue3";
import { mapGetters } from "vuex";
import VInput from "@/components/General/VInput";
import { getUnpaidFactors, submitFactor } from "@/API/API";

export default {
  name: "CartBottomSheet",
  components: {
    Sheet,
    VButton,
    CartFoodCard,
    VInput,
  },
  data() {
    return {
      bereng: 0,
      ezafe: 0,
      food: {},
      newFactor: {},
      loading: false,
      modalLogin: this.$modalLogin,
      modalAddRace: false,
      mab: 0,
      // Bind Local Cart data to Global $cart var
      cart: this.$cart,
      user: {
        name: this.$store.state.factor.taF_NAME,
        count: this.$store.state.factor.tedad,
      },
      tableNumber: this.$store.state.factor.desK_NUMBER,
      description: this.$store.state.factor.description,
      discountCode: "",
      paymentType: "pos",
      orderType: "restaurant",
    };
  },
  created() {
    console.log(this.$store.state.hsale.goods);
    console.log(this.$store.state.factorSum.paymentAfterTax);
  },
  computed: {
    foods() {
      return this.$store.state.hsale.goods;
    },
    count() {
      return (foodId) => this.$store.getters.productCount(foodId);
    },
    totalPrice() {
      return this.$store.state.factorSum.paymentAfterTax;
    },
    ...mapGetters(["totalCount"]),
  },
  methods: {
    submitOrder() {
      this.loading = true;
      const vm = this;
      // let factor = {
      //   user: vm.user,
      //   description: vm.description,
      //   tableNumber: vm.tableNumber,
      //   goods: this.$store.state.cart.products,
      //   orderType: vm.orderType,
      //   paymentType: vm.paymentType,
      //   discount: 0,
      // };
      console.log(vm);
      let factor = this.$store.state.hsale;
      (factor.description = vm.description),
        (factor.orderType = vm.orderType),
        (factor.paymentType = vm.paymentType),
        (factor.desK_NUMBER = this.tableNumber);
      factor.tedad = this.user.count;

      this.$store.dispatch("setNewFactorHsale", factor);
      for (let i = 0; i < factor.goods.length; i++) {
        if (factor.goods[i].hasRace == 1) {
          this.bereng = factor.goods[i].quantity;
        }
        if (factor.goods[i].kala == 21590005) {
          this.ezafe = factor.goods[i].quantity;
        }
      }

      if (this.ezafe < this.bereng) {
        this.$swal({
          icon: "warning",
          title: "یادآوری",
          text:
            "تعدادبرنج انتخابی (" +
            this.ezafe +
            ") باتعدادکالا دارای برنج (" +
            this.bereng +
            ") برابر نیست آیاادامه میدهید ؟",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "بله",
          showCancelButton: true,
          cancelButtonText: "خیر",
        }).then((result) => {
          if (result.isConfirmed) {
            if (this.user.count > this.$store.getters.countOfFoodProducts) {
              this.$swal({
                icon: "warning",
                title: "یادآوری",
                text: "تعداد غذا ها از تعداد افراد کمتر است، آیا تمایل به سفارش برنج یا سرویس اضافه دارید ؟",
                confirmButtonColor: "#fcd34d",
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: "خیر",
              }).then((result) => {
                if (result.isConfirmed) {
                  console.log("fff");
                  this.loading = false;
                  this.$router.push("/specialCategory/2");
                } else {
                  this.getUnpaidFactors();
                  console.log("eeee");
                }
              });
            } else {
              this.getUnpaidFactors();
            }
          } else {
            this.$router.replace("/menu/100");
            this.loading = false;
          }
        });
      } else {
        this.getUnpaidFactors();
      }
    },

    getUnpaidFactors() {
      if (this.$store.getters.isLoggedIn) {
        getUnpaidFactors()
          .then((resp) => {
            console.log(resp);
            if (resp.data.result > 0) {
              this.$swal({
                icon: "warning",
                title: "یادآوری",
                text: resp.data.message,
                confirmButtonColor: "#fcd34d",
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: "خیر",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.postOrder();
                  submitFactor;
                } else {
                  this.loading = false;
                }
              });
            } else {
              this.postOrder();
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
        console.log("qqqq");
        this.modalLogin = true;
      }
    },
    postOrder() {
      console.log("aaaa");
      submitFactor(this.$store.state.hsale)
        .then((resp) => {
          this.$swal({
            icon: "warning",
            title: "در انتظار پرداخت",
            text: resp.data.message,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          }).then(() => {
            if (this.paymentType === "online") {
              window.location.href = resp.data.result.paymentlink;
            } else {
              this.$router.replace(
                `/profile/factors/${resp.data.result[0].kind}`
              );
            }
            this.$cart.value = false;
          });
          this.$store.dispatch("emptyCart");
          this.description = this.$store.state.hsale.description;
          this.user.count = this.$store.state.tedad;
        })
        .catch((err) => {
          let unorderedList = document.createElement("ul");
          unorderedList.classList.add("text-sm", "text-right", "list-disc");

          err.response.data.result.forEach((error) => {
            let li = document.createElement("li");
            li.innerText = error;
            unorderedList.appendChild(li);
          });

          this.$swal({
            icon: "error",
            title: "خطا",
            html: unorderedList,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onFactorError() {
      console.log(this.food);
      // let unorderedList = document.createElement("div");
      // let img = document.createElement("<img :src='" + this.food.imgurl + "'");
      // unorderedList.appendChild(img);

      // let div = document.createElement("div");
      // div.classList.add("relative", "bg-white", "p-4");

      // let h = document.createElement("h1");
      // h.classList.add("text-lg", "mt-4", "text-center", "font-bold");
      // h.innerText = this.food.kala_Name;
      // div.appendChild(h);

      // let div2 = document.createElement("div");
      // div2.classList.add("flex", "justify-center", "mt-4");
      // div.appendChild(div2);

      // let div3 = document.createElement("div");
      // div3.classList.add("flex", "bg-gray-200", "rounded-full");
      // div2.appendChild(div3);

      // let div4 = document.createElement("div");
      // div4.classList.add("flex", "bg-brand", "rounded-full");
      // div3.appendChild(div4);

      // let span = document.createElement("span");
      // span.classList.add("p-2", "px-4", "font-bold");
      // span.innerText = "+";
      // div4.appendChild(span);

      // let span2 = document.createElement("span");
      // span2.classList.add("m-1", "p-1", "px-3", "bg-white", "rounded-full");
      // span2.innerText = this.count(this.food.kala);
      // div4.appendChild(span2);

      // let span3 = document.createElement("span");
      // span3.classList.add("p-2", "px-4", "font-bold");
      // span3.innerText = "-";
      // div4.appendChild(span3);

      // let span4 = document.createElement("span");
      // span4.classList.add("mr-2", "p-2");
      // span4.innerText = this.$helper.priceFormatter(
      //   (this.food.nerkh + this.food.nerkh * (this.food.afzodeAvarez / 100)) /
      //     10,
      //   false
      // );
      // div3.appendChild(span4);

      // let div5 = document.createElement("div");
      // div5.classList.add("flex", "justify-between");

      // let span5 = document.createElement("span");
      // span5.classList.add("text-brand");
      // span5.innerText = this.$helper.priceFormatter(
      //   Math.trunc(
      //     this.count(this.food.kala) * this.food.nerkh +
      //       this.count(this.food.kala) *
      //         this.food.nerkh *
      //         (this.food.afzodeAvarez / 100)
      //   ) / 10
      // );
      // div5.appendChild(span5);

      // let h2 = document.createElement("h1");
      // h2.classList.add("text-lg", "mt-4", "text-center", "font-bold");
      // h2.innerText = "جمع (با مالیات)";
      // div5.appendChild(h2);

      // div.appendChild(div5);

      // this.$swal({
      //   icon: "error",
      //   title: "خطا",
      //   html: unorderedList,
      //   confirmButtonColor: "#fcd34d",
      //   confirmButtonText: "باشه",
      // });
    },
  },
  watch: {
    // We watch this to update the tableNumber from QR reader
    cart() {
      this.tableNumber = this.$store.state.hsale.desK_NUMBER;
    },
  },
};
</script>

<style scoped></style>
